<template>
    <div class="subscribe">
        <h3 class="subscribe__title" v-html="$t('TotemSubscribe.subscribe')"></h3>
        <div class="subscribe__form" id="subscribeForm">
        </div>
    </div>
</template>

<script>
    import config from 'services/config'
    export default {
        name: 'footer-subscribe',
        methods: {
            createForm () {
                if (window.hbspt && window.hbspt.forms) {
                    window.hbspt.forms.create({
                        portalId: config.hubSpotPortalId,
                        formId: config.hubSpotNewsletterFormId,
                        target: '#subscribeForm' }
                    )
                } else {
                    setTimeout(this.createForm, 1000)
                }
            }
        },
        mounted () {
            setTimeout(this.createForm, 3000)
        }
    }
</script>

<style lang="scss">
    .hs-input {
        border: none;
        padding: 10px 105px 10px 25px;
        font-size: 1.6rem;
        border-radius: 20px;
        color: $black;
        height: 38px;
        width: 347px;

        &::placeholder {
            color: $boulder;
        }

        [class*="mobile"] &,
        [class*="desktop_l"] &,
        [class*="desktop_xl"] & {
            width: 100%;
        }
    }
    .hs-button {
        font-size: 1.6rem;
        white-space: revert !important;
        position: absolute;
        top: 4px;
        right: 4px;
        background-color: $rust_orange;
        color: $white;
        padding: 6px 20px;
        border-radius: 20px;
        font-weight: 600;
        border: none;
        height: 30px;
    }
    .hs-form-required {
        display: none;
    }
    .hs_submit {
        position: absolute;
        right: 0;
        top: 0;
    }
    .hs-form {
        position: relative;
    }
</style>
<style lang="scss" scoped>
   .subscribe {
       display: flex;
       flex-direction: column;
       align-items: flex-start;

       &__title {
           font-family: Nunito-ExtraBold, sans-serif;
           font-size: 1.6rem;
           margin: 0 0 10px;
       }

       &__form {
           position: relative;
           width: 100%;
       }
   }
</style>
